module.exports = __webpack_public_path__ + "img/索恩格.png";